import { render, staticRenderFns } from "./Navbar2.vue?vue&type=template&id=5452d570&scoped=true&"
import script from "./Navbar2.vue?vue&type=script&lang=js&"
export * from "./Navbar2.vue?vue&type=script&lang=js&"
import style0 from "./Navbar2.vue?vue&type=style&index=0&id=5452d570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5452d570",
  null
  
)

export default component.exports